import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

function prettyDate(date, format = null) {
  if (format) {
    return dayjs(date).format(format);
  } else {
    return dayjs(date).format("ddd, MMM D YYYY, h:mma");
  }
}
function myTimezone() {
  return dayjs.tz.guess();
}
function adjustTimePeriod(start, end) {
  let startDateTime = `${dayjs(start).format("YYYY-MM-DD")}T00:00:00.000000Z`;
  let endDateTime = `${dayjs(end).format("YYYY-MM-DD")}T23:59:59.000000Z`;
  const canadaOffset = dayjs
    .tz(new Date(startDateTime), "America/Toronto")
    .utcOffset();

  startDateTime = dayjs(startDateTime)
    .add(canadaOffset, "minute")
    .utc()
    .format();
  endDateTime = dayjs(endDateTime).add(canadaOffset, "minute").utc().format();

  return {
    start: startDateTime,
    end: endDateTime,
  };
}
function formatLocation(location) {
  const street = String(location.street).trim()
    ? `${String(location.street).trim()}, `
    : "";
  const city = String(location.city).trim()
    ? `${String(location.city).trim()}, `
    : "";
  const state = String(location.state).trim()
    ? `${String(location.state).trim()}`
    : "";
  return street + city + state;
}

export { prettyDate, myTimezone, adjustTimePeriod, formatLocation };
